export const currencySelectOptions = [
  { name: 'EUR', value: 'eur' },
  { name: 'USD', value: 'usd' },
  { name: 'GBP', value: 'gbp' },
  { name: 'SEK', value: 'sek' },
];

export const industrySelectOptions = [
  { name: 'Select your industry', value: '' },
  { name: 'AdTech / MarTech / Media', value: 'adtech-media' },
  { name: 'AgriTech', value: 'agritech' },
  { name: 'AI / Big Data / Analytics', value: 'big-data' },
  { name: 'Consumer Goods / Lifestyle', value: 'consumer-goods' },
  { name: 'Cybersecurity / Privacy', value: 'cybersecurity' },
  { name: 'DeepTech / Emerging Technologies', value: 'deep-tech' },
  { name: 'DefenceTech / Dual-Use Technologies', value: 'defence-tech' },
  { name: 'E-commerce / Marketplaces', value: 'ecommerce' },
  { name: 'EdTech', value: 'edtech' },
  { name: 'Entertainment / Music / Gaming', value: 'entertainment' },
  { name: 'Fashion / Beauty', value: 'fashion' },
  { name: 'FinTech / Financial Services', value: 'fintech' },
  { name: 'FoodTech', value: 'foodtech' },
  { name: 'GreenTech / ClimateTech / Energy', value: 'greentech' },
  { name: 'Healthcare / MedTech / Life Sciences', value: 'healthtech' },
  { name: 'HRTech / Future of Work', value: 'hrtech' },
  { name: 'ImpactTech / Social Innovation', value: 'impacttech' },
  { name: 'IndustrialTech / Robotics / Advanced Manufacturing', value: 'industrialtech' },
  { name: 'IT / Software / SaaS', value: 'it-software' },
  { name: 'LegalTech / RegTech', value: 'legaltech' },
  { name: 'Mobility / Transportation / Logistics', value: 'transport-logistics' },
  { name: 'PropTech / ConstructionTech', value: 'proptech' },
  { name: 'Retail / Commerce', value: 'retail' },
  { name: 'SpaceTech / Aerospace', value: 'space-tech' },
  { name: 'Travel / Hospitality', value: 'travel-hospitality' },
  { name: 'Water / Circular Economy', value: 'water-circular' },
];

/** Express signup / free-text industry when the predefined list does not fit. */
export const INDUSTRY_OTHER_VALUE = 'other';

/** Older catalogs stored this as a second "Software / SaaS" industry. */
const LEGACY_SOFTWARE_INDUSTRY = 'software';
const CANONICAL_SOFTWARE_INDUSTRY = 'it-software';

export function canonicalIndustryValue(value: string): string {
  return value === LEGACY_SOFTWARE_INDUSTRY ? CANONICAL_SOFTWARE_INDUSTRY : value;
}

export function canonicalIndustryList(values: string[]): string[] {
  const seen = new Set<string>();
  const next: string[] = [];
  values.forEach(value => {
    const canonical = canonicalIndustryValue(value);
    if (!canonical || seen.has(canonical)) return;
    seen.add(canonical);
    next.push(canonical);
  });
  return next;
}

export const stageSelectOptions = [
  { name: 'Select your stage of development', value: '' },
  { name: 'Early/Seed', value: 'early-seed' },
  { name: 'Growth', value: 'growth' },
  { name: 'Series A', value: 'series-a' },
  { name: 'Series B/Higher', value: 'series-b-higher' },
];

export const modelSelectOptions = [
  { name: 'Select your business model', value: '' },
  { name: 'B2C', value: 'b2c' },
  { name: 'B2B', value: 'b2b' },
  { name: 'B2B and B2C', value: 'b2b-b2c' },
];

export const productTypeSelectOptions = [
  { name: 'Select from the following', value: '' },
  { name: 'Software', value: 'software' },
  { name: 'SaaS', value: 'software-saas' },
  { name: 'Hardware / physical products', value: 'hardware' },
  { name: 'Services', value: 'services' },
  { name: 'Platform/Marketplace', value: 'platform-marketplace' },
  { name: 'Consumer Goods', value: 'consumer-goods' },
];
